import React, { useContext, useEffect, useState } from 'react'
import { SwitchBox, SwitchDiv, SwitchesDiv, SwitchInput, SwitchSlider } from './style'
import { getHeadersByTenant, getPermissionsByTenant } from '../utils'
import { useTenant } from '../../../../contexts/TenantContext'
import axios from '../../../../config/axios'
import UserContext from '../../../../contexts/UserContext'
import { useProfileContext } from '../../../../contexts/AccessesContext'
import trash from '../../../../assets/assesses/trash.svg'
import ModalContext from '../../../../contexts/ModalContext'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import { GlobalTable, HeaderLine, Td, Th, Tr, FooterTr } from '../../../../components/styles/table-style'
import { useOutletContext } from 'react-router-dom'
import { PeopleOutletType } from '..'

interface Profile {
  id: number
  name: string
  admin: boolean
  permissions: string[]
  createdAt: string
  updatedAt: string
}

const TableProfile = () => {
  const { profiles, setProfiles, setDeletedProfile, fetchProfilesWithoutAdmin, loadQuantity, setLoadQuantity, hasMoreProfiles, totalProfiles } = useProfileContext()
  const [checkedState, setCheckedState] = useState<{ [key: string]: boolean }>({})
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const [refreshTrigger, setRefreshTrigger] = useState(0)
  const { setTabIndex } = useOutletContext<PeopleOutletType>()
  const { user } = useContext(UserContext)
  const { tenantId } = useTenant()

  if (tenantId === null) {
    return <div>Carregando tenant...</div>
  }

  const headerProfilesTable = getHeadersByTenant(tenantId)
  const allPermissions = getPermissionsByTenant(tenantId)

  useEffect(() => {
    setTabIndex(1)
  }, [])

  useEffect(() => {
    const initialCheckedState: { [key: string]: boolean } = {}

    profiles.forEach((profile) => {
      allPermissions.forEach((permission, permissionIndex) => {
        const key = `${profile.id}-${permissionIndex}`
        initialCheckedState[key] = profile.permissions.includes(permission)
      })
    })
    setCheckedState(initialCheckedState)
  }, [profiles, allPermissions])

  const handleDelete = async (id: number) => {
    setDeletedProfile(id)
    setModalActive(true)
    setModalSection('deleteProfile')
  }

  const updateProfilePermissions = async (profileId: number, updatedPermissions: string[]) => {
    try {
      await axios.patch(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/profile/${profileId}`,
        { permissions: updatedPermissions }
      )
    } catch (error) {
      console.error('Erro ao atualizar permissões', error)
    }
  }

  const handleCheckboxChange = (profileId: number, permissionIndex: number) => {
    const key = `${profileId}-${permissionIndex}`
    const permissionName = allPermissions[permissionIndex]

    setCheckedState((prevCheckedState) => {
      const newCheckedState = {
        ...prevCheckedState,
        [key]: !prevCheckedState[key],
      }

      const profile = profiles.find(p => p.id === profileId)
      if (!profile) return prevCheckedState

      if (newCheckedState[key]) {
        if (!profile.permissions.includes(permissionName)) {
          profile.permissions.push(permissionName)
        }
      } else {
        profile.permissions = profile.permissions.filter((perm) => perm !== permissionName)
      }

      updateProfilePermissions(profile.id, profile.permissions)

      return newCheckedState
    })
  }

  const itemsOfTable = (permissionType: string, profileId: number, permissionIndex: number, id: number) => {
    const element = permissionType !== 'delete' ? (
      <SwitchesDiv>
        <SwitchDiv>
          <SwitchBox>
            <SwitchInput
              type="checkbox"
              checked={checkedState[`${profileId}-${permissionIndex}`] || false}
              onChange={() => handleCheckboxChange(profileId, permissionIndex)}
            />
            <SwitchSlider className="slider"></SwitchSlider>
          </SwitchBox>
        </SwitchDiv>
      </SwitchesDiv>
    ) : (
      <img src={trash} alt="trash icon" onClick={() => handleDelete(id)} className="trash" />
    )

    return element
  }

  return (
    <>
      <GlobalTable>
        <thead>
          <HeaderLine>
            {headerProfilesTable.map((item, indexHeader) => (
              <Th key={indexHeader}>{item}</Th>
            ))}
          </HeaderLine>
        </thead>
        <tbody>
          {profiles.map((profile) => (
            <Tr key={profile.id}>
              {allPermissions.map((permission, indexPermissions) => (
                <Td key={indexPermissions}>
                  {permission === 'name' ? <>{profile.name}</> : itemsOfTable(permission, profile.id, indexPermissions, profile.id)}
                </Td>
              ))}
            </Tr>
          ))}
        </tbody>
        <tfoot>
          <FooterTr>
            <Td colSpan={headerProfilesTable.length} style={{ textAlign: 'center', background: 'transparent' }}>
              <LoadMoreButton
                currentCount={profiles.length}
                totalCount={totalProfiles ?? undefined}
                onLoadMore={() => setLoadQuantity(prev => prev + 10)}
                hasMore={hasMoreProfiles}
              />
            </Td>
          </FooterTr>
        </tfoot>
      </GlobalTable>
    </>
  )
}

export default TableProfile

